import React, { FC } from 'react';

import { tablet } from 'mintel-tokens/dist/tokens.module.js';
import { useMediaQuery } from 'react-responsive';

export const GRID_BASE_WIDTH = 12;

export const useColsCollapsed = (): boolean =>
  !useMediaQuery({
    query: `(min-width: ${tablet})`,
  });

export enum LAYOUT {
  LEFT = 'left',
  RIGHT = 'right',
  EQUAL = 'equal',
}

export type columnNames = 'media' | 'content' | 'stat';

export const DangerousB: FC<{ className?: string }> = ({
  children,
  className = '',
}) => {
  return typeof children === 'string' ? (
    <b className={className} dangerouslySetInnerHTML={{ __html: children }} />
  ) : (
    <b className={className}>{children}</b>
  );
};

export const DangerousCite: FC<{ className?: string }> = ({
  children,
  className = '',
}) => {
  return typeof children === 'string' ? (
    <cite
      className={className}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  ) : (
    <cite className={className}>{children}</cite>
  );
};

export const DangerousP: FC<{ className?: string }> = ({
  children,
  className = '',
}) => {
  return typeof children === 'string' ? (
    <p className={className} dangerouslySetInnerHTML={{ __html: children }} />
  ) : (
    <p className={className}>{children}</p>
  );
};

export const DangerousSpan: FC<{ className?: string }> = ({
  children,
  className = '',
}) => {
  return typeof children === 'string' ? (
    <span
      className={className}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  ) : (
    <span className={className}>{children}</span>
  );
};

export const DangerousH2: FC<{ className?: string }> = ({
  children,
  className = '',
}) => {
  return typeof children === 'string' ? (
    <h2 className={className} dangerouslySetInnerHTML={{ __html: children }} />
  ) : (
    <h2 className={className}>{children}</h2>
  );
};

export const DangerousH4: FC<{ className?: string }> = ({
  children,
  className = '',
}) => {
  return typeof children === 'string' ? (
    <h4 className={className} dangerouslySetInnerHTML={{ __html: children }} />
  ) : (
    <h4 className={className}>{children}</h4>
  );
};
